import React from 'react';
import OrdersListPage from 'modules/my-sales/submodules/orders/list/page';

const OrdersPage = () => {
  return <OrdersListPage />;
};

export default OrdersPage;
